/*
 *
 * TransactionsDownloadAllPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jun-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.title'
      defaultMessage='Scarica tutte le transazioni'
    />
  ),
  close: (
    <PortalMessage
      id='t.app.close'
      defaultMessage='Chiudi'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.primaryButtonLabel'
      defaultMessage='Scarica CSV'
    />
  ),
  secondaryButtonLabel: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.secondaryButtonLabel'
      defaultMessage='Scarica XLS'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.description'
      defaultMessage='La generazione del file potrebbe richiedere qualche minuto. Quando sarà pronto, clicca per scaricarlo sul tuo dispositivo.'
    />
  ),
  formatInfoMessage: (
    <PortalMessage
      id='t.app.costs.custom.download.modal.format.info'
      defaultMessage='Seleziona il formato di file che preferisci. Se il volume delle transazioni è elevato, verrà generato un archivio ZIP con i dati in formato CSV.'
    />
  )
}

export default formattedMessage
